"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Utility class
 * @author david.petrosyan
 */
var Utils = /** @class */ (function () {
    function Utils() {
    }
    /**
     * Convert object to Map class
     * @param obj object to be converted
     * @returns {Map<number, string>} converted object
     */
    Utils.convertObjectToMap = function (obj) {
        var strMap = new Map();
        for (var prop in obj) {
            strMap.set(Number(prop), obj[prop]);
        }
        return strMap;
    };
    Utils.mapToObject = function (name) {
        var nameObject = {};
        name.forEach(function (value, key) {
            nameObject[key] = value;
        });
        return nameObject;
    };
    return Utils;
}());
exports.Utils = Utils;
//# sourceMappingURL=utils.js.map